import { render, staticRenderFns } from "./docs.vue?vue&type=template&id=0cc392b4&scoped=true&"
import script from "./docs.vue?vue&type=script&lang=js&"
export * from "./docs.vue?vue&type=script&lang=js&"
import style0 from "./docs.vue?vue&type=style&index=0&id=0cc392b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc392b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc392b4')) {
      api.createRecord('0cc392b4', component.options)
    } else {
      api.reload('0cc392b4', component.options)
    }
    module.hot.accept("./docs.vue?vue&type=template&id=0cc392b4&scoped=true&", function () {
      api.rerender('0cc392b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/docs.vue"
export default component.exports